import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import CustomLoader from '../common/CustomLoader';
import CustomSelect from '../../common/formElements/CustomSelect';
import Select from 'react-select';
import ParentContentCard from '../common/ParentContentCard';
export class XanoProjectslist extends Component {
  static propTypes = {
    projectOnBoard: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selectedOption: null,
    selectError: '',
  };

  handleApi = async (id) => {
    const { projectId, version } = this.props.match.params;
    const { actions, history, projectOnBoard } = this.props;
    const { token } = history.location.state;
    try {
      await actions.xanoProjectslist({ token, id });
      if (this.props.projectOnBoard.xanoData) {
        const tablesarr = this.props.projectOnBoard.xanoProjectsData.map(
          ({ id, name, description, guid, auth }) => ({ id, name, description, guid, auth }),
        );
        const modifiedObject = {
          name: this.state.selectedOption.label,
          id: this.state.selectedOption.value,
        };
        console.log(modifiedObject);
        const dataForSave = {
          projectId,
          type: 'XANO',
          setting: {
            xanoApiAccessToken: token,
          },
          completeData: {
            workspace: modifiedObject,
            tables: tablesarr,
          },
        };
        await actions.apisaveDataCall({ dataForSave, projectId, version });
        this.props.history.push(
          `/project-on-board/${version}/v/${this.props.match.params.projectId}/xano-collection-namelist`,
          {
            token: token,
            projectOnBoard: projectOnBoard,
            allColname: this.props.projectOnBoard.xanoProjectsData,
            idwork: this.state.selectedOption,
          },
        );
      }
    } catch (error) {
      console.error('API call error:', error);
    }
  };

  handleChange = (name, value) => {
    this.setState({ selectedOption: value });
  };

  handleSendRequset = () => {
    if (this.state.selectedOption) {
      this.handleApi(this.state.selectedOption.value);
    } else {
      this.setState({ selectError: 'Select DataBase !' });
    }
  };

  render() {
    const { projectOnBoard, history, match } = this.props;
    const { projectId } = match.params;
    const { xanoProjectsData, xanoData, xanoProjectslistPending } = projectOnBoard;
    const dropdown = xanoData.map((item, index) => ({
      label: item.name,
      value: item.id,
    }));

    if (!xanoData.length > 0) {
      history.push(`/collections/${projectId}/create`, {
        select: "XANO"
      });
      return null;
    }
    return (
      <>
        <CommonPageComponent>
          <ParentContentCard title="Choose Database for Creating Collection" icon="collection">
            <Formik initialValues={{}}>
              {({ values, handleChange, setFieldValue }) => (
                <Form className="form-row">
                  <div className="container">
                    <div className="row justify-content-center">
                      <div className="col-md-6">
                        <div className="text-center mb-3">
                          <CustomSelect
                            name="selectedDatabase"
                            isMulti={false}
                            isObject={true}
                            options={dropdown}
                            onBlur={() => { }}
                            value={this.state.selectedDatabase}
                            placeholder="Select Database"
                            onChange={this.handleChange}
                          />
                          {this.state.selectError && (
                            <p className="text-danger">{this.state.selectError}</p>
                          )}
                        </div>
                        <div className="text-right">
                          <button
                            className="btn btn-theme-submit"
                            onClick={this.handleSendRequset}
                            disabled={xanoProjectslistPending}
                          >
                            <i className="wb webconnect-rocket"></i>
                            &nbsp;Continue&nbsp;
                            <CustomLoader loading={xanoProjectslistPending}></CustomLoader>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </ParentContentCard>
        </CommonPageComponent>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectOnBoard: state.projectOnBoard,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XanoProjectslist);
